import { hotList } from "@/mocks/news";

export default function HotRanking() {
  const top = hotList.slice(0, 3);
  const rest = hotList.slice(3);

  return (
    <section id="hot" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-fire-fill" />
              Hot Ranking
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              今日热榜
            </h2>
            <p className="mt-2 max-w-lg text-sm text-foreground-700">
              吃瓜51全网热度实时聚合，看看此刻大家都在关注什么。
            </p>
          </div>
          <span className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-600">
            <i className="ri-restart-line text-primary-500" />
            热度数据每日持续刷新
          </span>
        </div>

        {/* TOP3 大卡 */}
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {top.map((item) => (
            <button
              key={item.rank}
              type="button"
              onClick={() =>
                document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" })
              }
              className={`group relative overflow-hidden rounded-2xl p-6 text-left transition-transform hover:-translate-y-1 md:p-7 ${
                item.rank === 1
                  ? "bg-gradient-to-br from-primary-500 to-primary-600 text-background-50"
                  : item.rank === 2
                    ? "bg-gradient-to-br from-accent-500 to-accent-600 text-background-50"
                    : "bg-gradient-to-br from-secondary-500 to-secondary-600 text-background-50"
              }`}
            >
              <span className="absolute right-4 top-4 flex items-center gap-1 rounded-full bg-background-50/20 px-2.5 py-1 text-xs font-semibold">
                <i className="ri-medal-fill" />
                NO.{item.rank}
              </span>
              <i className="ri-fire-fill text-5xl opacity-20 transition-opacity group-hover:opacity-40" />
              <h3 className="relative mt-3 font-heading text-lg font-bold leading-snug md:text-xl">
                {item.title}
              </h3>
              <div className="relative mt-4 flex items-center gap-3 text-sm opacity-90">
                <span className="flex items-center gap-1">
                  <i className="ri-hotspot-fill" />
                  热度 {item.heat}
                </span>
                <span className="rounded-full bg-background-50/25 px-2 py-0.5 text-xs">
                  {item.tag}
                </span>
              </div>
            </button>
          ))}
        </div>

        {/* 其余排名列表 */}
        <div className="mt-6 grid gap-5 lg:grid-cols-2">
          <div className="space-y-1 rounded-2xl border border-background-200 bg-background-50 p-3 md:p-4">
            {rest.slice(0, 4).map((item, idx) => (
              <RankRow key={item.rank} item={item} globalIndex={idx + 3} />
            ))}
          </div>
          <div className="space-y-1 rounded-2xl border border-background-200 bg-background-50 p-3 md:p-4">
            {rest.slice(4).map((item, idx) => (
              <RankRow key={item.rank} item={item} globalIndex={idx + 7} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function RankRow({ item, globalIndex }: { item: (typeof hotList)[number]; globalIndex: number }) {
  const trendIcon =
    item.trend > 0
      ? { i: "ri-arrow-up-line", c: "text-primary-500", t: `较昨日 +${item.trend}` }
      : item.trend < 0
        ? { i: "ri-arrow-down-line", c: "text-secondary-600", t: `较昨日 ${item.trend}` }
        : { i: "ri-arrow-right-up-line", c: "text-accent-600", t: "保持热度" };

  return (
    <button
      type="button"
      onClick={() => document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" })}
      className="group flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition-colors hover:bg-secondary-100 md:gap-4"
    >
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-secondary-200 font-heading text-sm font-bold text-foreground-700">
        {globalIndex + 1}
      </span>
      <span className="flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
        {item.title}
      </span>
      <span className={`hidden items-center gap-0.5 whitespace-nowrap text-xs sm:flex ${trendIcon.c}`} title={trendIcon.t}>
        <i className={trendIcon.i} />
        {trendIcon.t.replace("较昨日 ", "")}
      </span>
      <span className="whitespace-nowrap text-xs text-foreground-600">{item.heat}</span>
    </button>
  );
}